import type { ChipProps } from '@mui/material';
import { Chip, Paper, Stack, Typography } from '@mui/material';
import EmptyData from '../../../../assets/images/empty-data-image.svg';
import { HomePageEndOfMonthStatIcon } from './HomePageEndOfMonthCardIcon';

type HomePageEndOfMonthStatCardProps = {
  label: string;
  subLabel: string;
  emptyState?: boolean;
  chipLabel: React.ReactNode;
  logoColor: string;
  chipColor: ChipProps['color'];
};

export const HomePageEndOfMonthStatCard: React.FC<HomePageEndOfMonthStatCardProps> = ({ chipLabel, logoColor, label, subLabel, chipColor, emptyState = false }) => {  
  return (
    <Paper
      variant="outlined"
      sx={{
        height: '120px',
      }}
    >
      <Stack
        direction='row'          
        alignItems="center"
        justifyContent="space-between"
        height="100%"
      >
        <Stack
          padding="12px 16px 12px 16px"
          gap={1}
        >
          <Typography
            fontSize={emptyState ? undefined : '13px'}
            lineHeight={emptyState ? undefined : '18px'}
            fontWeight={emptyState ? undefined : 400}
            variant={emptyState ? 'h6' : undefined}
            color={emptyState ? undefined : theme => theme.palette.text.secondary}
          >
            {label}
          </Typography>
          <Typography
            variant={emptyState ? 'body2' : 'h5'}
            color={emptyState ? 'text.secondary' : undefined}
          >
            {subLabel}
          </Typography>
          {!emptyState && (
            <Chip
              label={chipLabel}
              variant='outlined'
              size='small'
              color={chipColor}
            />
          )}
        </Stack>
        {emptyState ? 
          <img
            src={EmptyData}
            alt="Empty Data"
          /> : 
          <HomePageEndOfMonthStatIcon color={logoColor} />}
      </Stack>
    </Paper>
  );
};